import { network } from 'services/network';

import { QueryParams } from 'api/queries/getDelayDriver.query';

export const ENDPOINT = 'api/bo/getDelayDriver';

export const getDelayDriver = (params: QueryParams) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
